import isValidId from '@/utils/helpers/isValidId';
import { DEFAULT_CATEGORY_ID } from '@/utils/constants/spaceCategories';

export default function (categoryId) {
  return categoryId === DEFAULT_CATEGORY_ID || isValidId(categoryId);
}
